import { render } from "./CardComp.vue?vue&type=template&id=14e38a94&scoped=true"
import script from "./CardComp.vue?vue&type=script&lang=js"
export * from "./CardComp.vue?vue&type=script&lang=js"

import "./CardComp.vue?vue&type=style&index=0&id=14e38a94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e38a94"]])

export default __exports__